export default class {
	id
	name
	code
	constructor( id = null, name = null, code = null){
		this.uuid = id;
		this.name = name;
		this.code = code;
	}
}